import { LAWFIRMS_BOOKMARKED } from "../constants/types";

export default function(state=[], action){
    switch(action.type){
      case LAWFIRMS_BOOKMARKED:
        return action.payload
      default:
        return state
    }
  }